import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | KEYMAP_COLUMN] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | KEYMAP_COLUMN] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | KEYMAP_COLUMN] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | KEYMAP_COLUMN] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | KEYMAP_COLUMN] Add Entity',
  UpdateEntity = '[STORE | ENTITY | KEYMAP_COLUMN] Update Entity',
  RemoveEntity = '[STORE | ENTITY | KEYMAP_COLUMN] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | KEYMAP_COLUMN] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | KEYMAP_COLUMN] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | KEYMAP_COLUMN] Clean Up Snapshots',
  RearrangeKeymapColumns = '[STORE | ENTITY | KEYMAP_COLUMN] Rearrange Keymap Columns',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.KeymapColumnEntityModels.KeymapColumn> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.KeymapColumnEntityModels.KeymapColumn> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.KeymapColumnEntityModels.KeymapColumn> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Rearrange Keymap Columns
 */
export class RearrangeKeymapColumns {
  public static readonly type = ActionTypes.RearrangeKeymapColumns;
  
  public constructor(public keymapColumns: FlatModels.KeymapColumnEntityModels.KeymapColumn[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>